// for some tables, display a different table name for added clarity
const tablenameMap = {
  'greenhouse_officeholder_page_update':                    'officeholder_greenhouse',
  'greenhouse_page_creation':                               'candidate_greenhouse',
  'local_candidate_endorsements_staged_and_prod_worksheet': 'all_endorsements_per_candidate',
};

export default {
  methods: {
    readableName(tablename) {
      if (tablename in tablenameMap) {
        tablename = tablenameMap[tablename];
      }
      // tablename is a string
      return tablename.replace(/_/g, ' ')
            .toLowerCase()
            .split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ')
            .split('.')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join('.');
    },
    readableTableName(table) {
      // table is an object with a name property
      return this.readableName(table.name);
    }
  }
}
